// ON RESIZE
import { BREAKPOINTS } from '@/config'

export function getBreakPoints () {
  const layout = {
    isXS: false,
    isSM: false,
    isMD: false,
    isLG: false,
    isXL: false,
    isMobile: false,
    isTablet: false,
    isDesktop: false
  }
  // Calc layout
  if (window.innerWidth < BREAKPOINTS.sm) {
    layout.isXS = true
    layout.isMobile = true
  } else if (window.innerWidth < BREAKPOINTS.md) {
    layout.isSM = true
    layout.isTablet = true
  } else if (window.innerWidth < BREAKPOINTS.lg) {
    layout.isMD = true
    layout.isTablet = true
  } else if (window.innerWidth < BREAKPOINTS.xl) {
    layout.isLG = true
    layout.isDesktop = true
  } else {
    layout.isXL = true
    layout.isDesktop = true
  }
  return layout
}
